(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  const setLuminArteMenuMetrics = () => {
    const announcementBar = document.querySelector('.announcement-bar-section .utility-bar');
    const headerWrapper = document.querySelector('.header-wrapper');

    if (!announcementBar) {
      document.documentElement.style.setProperty('--la-announcement-visible-height', '0px');
    } else {
      const rect = announcementBar.getBoundingClientRect();
      const visibleHeight = Math.max(0, Math.min(rect.height, rect.bottom) - Math.max(0, rect.top));
      document.documentElement.style.setProperty('--la-announcement-visible-height', `${Math.round(visibleHeight)}px`);
    }

    if (headerWrapper) {
      const headerBottom = Math.round(headerWrapper.getBoundingClientRect().bottom);
      document.documentElement.style.setProperty('--la-menu-top', `${headerBottom}px`);
    }
  };

  setLuminArteMenuMetrics();
  window.addEventListener('resize', setLuminArteMenuMetrics);
  window.addEventListener('scroll', setLuminArteMenuMetrics, { passive: true });

  const mobileMenus = document.querySelectorAll('[data-la-mobile-menu]');

  const closeLuminArteMenu = (menu) => {
    menu.classList.remove('is-open');
    const trigger = menu.querySelector('[data-la-mobile-menu-trigger]');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');

    if (!document.querySelector('.la-mobile-menu.is-open')) {
      document.body.classList.remove('la-mobile-menu-open');
    }
  };

  const openLuminArteMenu = (menu) => {
    const trigger = menu.querySelector('[data-la-mobile-menu-trigger]');
    setLuminArteMenuMetrics();
    menu.classList.add('is-open');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    document.body.classList.add('la-mobile-menu-open');
  };

  mobileMenus.forEach((menu) => {
    const trigger = menu.querySelector('[data-la-mobile-menu-trigger]');
    const overlay = menu.querySelector('[data-la-mobile-menu-overlay]');

    if (!trigger || !overlay) return;

    trigger.addEventListener('click', () => {
      if (menu.classList.contains('is-open')) {
        closeLuminArteMenu(menu);
      } else {
        openLuminArteMenu(menu);
      }
    });

    overlay.addEventListener('click', () => closeLuminArteMenu(menu));

    menu.querySelectorAll('a.la-mobile-menu__link, a.la-mobile-menu__sublink').forEach((link) => {
      link.addEventListener('click', () => closeLuminArteMenu(menu));
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    mobileMenus.forEach((menu) => {
      if (menu.classList.contains('is-open')) {
        closeLuminArteMenu(menu);
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
